import { AspectRatio } from '@mantine/core';
import { useSelector } from "react-redux";

/**
 * Renders am iframe for a document to be signed.
 *
 * @param {Object} props - The component props.
 * @param {string} props.resourceId - The ID of the resource to display.
 * @return {JSX.Element} The JSX element representing the signed document.
 */
const UserShowSignDocStapel = (props:any ) => {
    console.log("UserShowSignDocStapel props:",props)
    const showdocstapel = useSelector((state: any) => state.user.userhavetostapelsigndocs)
   
    let doclinkstapellink = showdocstapel.filter((obj: { id: any }) => {
        return obj.id === props.stapelid
      });

    let drnstapellink  
    if (doclinkstapellink){
       drnstapellink = doclinkstapellink[0].stapelSignLink
    }
    
    return (
      <>
        <AspectRatio ratio={16 / 9} sx={{ maxWidth: 1920 }} mx="auto">
          <iframe
              src={drnstapellink}
              title={"Testraum"}
              allow="camera;microphone;display-capture"
              allowFullScreen
              frameBorder= "0"
            />
        </AspectRatio>
      </>
    )
};

export default UserShowSignDocStapel;